import { useEffect, useState } from "react";
import { Button, Checkbox, Flex, Form, Input, Switch } from "antd";
import { MasterDataServices } from "../../../../services/master-data";
import { useMessageApi } from "../../../../context/MessageContext";
import { IMasterData, IMasterDataInput, IMasterDataResponse } from "../../../../interfaces/master-data";
import { NOMINAL_CODE_TYPES } from "../../../../constants/enum";

interface CreateAndEditNominalCodesProps {
  onClose: (okTriggered?: boolean) => void;
  masterData: IMasterData | undefined;
  type: NOMINAL_CODE_TYPES;
}

interface INominalCodeInput {
  type: string;
  code: string;
  label: string;
  isActive: boolean;
  premiereGolfNominal: boolean;
}

const CreateAndEditNominalCodes: React.FC<CreateAndEditNominalCodesProps> = ({ onClose, masterData, type }) => {
  const [form] = Form.useForm();
  const messageApi = useMessageApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isEdit = !!masterData;

  useEffect(() => {
    if (masterData) {
      form.setFieldsValue({
        type: masterData.type,
        code: masterData.code,
        label: masterData.label,
        isActive: masterData.isActive,
        premiereGolfNominal: masterData.premiereGolfNominal,
      } as INominalCodeInput);
    }
  }, [form, masterData]);

  const onFinish = async (values: INominalCodeInput) => {
    try {
      setIsSubmitting(true);
      const payload: IMasterDataInput = {
        type: masterData?.type ?? type,
        code: values.code,
        label: values.label?.trim(),
        isActive: values.isActive,
        premiereGolfNominal: values.premiereGolfNominal,
      };

      const response: IMasterDataResponse = isEdit
        ? await MasterDataServices.update(String(masterData.id), payload)
        : await MasterDataServices.create(payload);

      if (response.success) {
        messageApi.success(isEdit ? "Update Nominal code successfully" : "New Nominal code created successfully");
        onClose(true);
      } else {
        messageApi.error(response.message);
      }
    } catch (error: any) {
      messageApi.error(error?.message || "Failed to save Nominal codes");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 18 }}
      // style={{ whiteSpace: "normal" }}
      onFinish={onFinish}
      initialValues={{ isActive: false }}
    >
      <Form.Item
        label="Value"
        name="code"
        rules={[
          { required: true, message: "Complete this required field." },
          {
            pattern: /^\d{1,4}$/,
            message: "Value maximum 4 numeric characters.",
          },
        ]}
      >
        <Input placeholder="Enter code" />
      </Form.Item>

      <Form.Item label="Active" name="isActive" valuePropName="checked">
        <Switch />
      </Form.Item>
      {type === NOMINAL_CODE_TYPES.DEBIT && (
        <Form.Item
          name="premiereGolfNominal"
          valuePropName="checked"
          label="Premiere Golf Nominal"
          labelCol={{ span: 10 }}
          style={{marginLeft: 14}}
        >
          <Checkbox />
        </Form.Item>
      )}

      <Flex justify="end" gap={16}>
        <Button onClick={() => onClose()} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button type="primary" htmlType="submit" loading={isSubmitting}>
          {isEdit ? "Update" : "Create"}
        </Button>
      </Flex>
    </Form>
  );
};

export default CreateAndEditNominalCodes;
